import { $http } from "@/plugins/api";
import { useFlag } from "@/composables/useFlags/useFlag";

const { isFeatureAvailable: isIncidentsV3Available } = useFlag("INCIDENTS_V3");

const state = {
  messagesAnalysed: [],
};

const getters = {
  messagesAnalysed: (state) => state.messagesAnalysed,
};

const actions = {
  async getMessagesAnalysed({ commit }, { globalOrganisationID, params }) {
    const filterParams = new URLSearchParams(params);

    if (isIncidentsV3Available.value) {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT_V3
        }/history/globalOrganisationID/${globalOrganisationID}/stats/messages?${filterParams.toString()}`,
      );

      commit("setMessagesAnalysed", res.data.data);
    } else {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT
        }/v1/pt/history/globalOrganisationID/${globalOrganisationID}/stats/messages?${filterParams.toString()}`,
      );

      commit("setMessagesAnalysed", res.data.data);
    }
  },
};

const mutations = {
  setMessagesAnalysed: (state, data) => (state.messagesAnalysed = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
